import { Component, input, OnInit } from '@angular/core';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import { Phone, PhoneServiceSubscription, ServiceUrlButton } from '../../../models/generated/ziroModels';
import { ZiroSelectConfig } from '../../../../forms/fields/select/ziro-select.component';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

@Component({
  selector: 'ziro-phone-buttons-service-url-helpdesk',
  templateUrl: './phone-buttons-service-url-helpdesk.component.html',
  imports: [ZiroFormsModule],
})
export class PhoneButtonsServiceUrlHelpdeskComponent
  extends ZiroFormAbstractDirective<ServiceUrlButton>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;

  readonly phone = input<Phone>();

  protected formConfig: ZiroFormConfig;

  ngOnInit(): void {
    const serviceSubscriptionNames = this.phone().serviceSubscriptions.map(
      (serviceSubscription: PhoneServiceSubscription) => serviceSubscription.phoneServiceSubscriptionName,
    );

    this.formConfig = {
      fields: {
        subscriptionName: {
          label: 'tkey;shared.device.phone.phone_buttons.features.service_url_feature.service_subscription.label',
          dataAutomation: 'phone-button-service-url-subscription-name',
          componentConfig: new ZiroSelectConfig({ options: serviceSubscriptionNames }),
        },
        label: {
          label: 'tkey;shared.device.buttonLayout.features.serviceUrlFeature.label.label',
          dataAutomation: 'phone-button-service-url-label',
        },
      },
      options: {
        columnClasses: {
          label: 'col-3 text-lg-end',
          input: 'col-9',
        },
      },
    } as ZiroFormConfig;
  }

  submit(): Observable<any> {
    return this.parentSubmit$();
  }
}
